import React, { useState } from "react";
import TreeView from "@material-ui/lab/TreeView";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";

import config from "../../../utils/config";

import TreeItemMiddle from "../CommonComponents/TreeItemMiddle";

export default function TreeContainer({ data, selected, setSelected }) {
  const { dma } = config;
  const [isOpenNestedParent, setIsOpenNestedParent] = useState([]);

  const removeTargetItem = (target, array) => {
    const elementsIndexToRemove = array.indexOf(target);
    elementsIndexToRemove !== -1 && array.splice(elementsIndexToRemove, 1);
  };

  const uncheckParentNodeFirstLvl = (id, array) => {
    const selectedNestedNode = dma.find((item) => item.valueDMA === +id);
    const groupIdForChecking = selectedNestedNode.ST;
    const targetGroup = data.find((group) => group.id === groupIdForChecking);

    const nestedItemsIsSelected = targetGroup.children.some((item) =>
      array.includes(item.id)
    );

    !nestedItemsIsSelected && removeTargetItem(groupIdForChecking, array);
  };

  const getSelectedNode = (node) => {
    //case for state branch
    if (node.id.length === 2) {
      const idsList = [];
      idsList.push(node.id);
      node.children.forEach((item) => idsList.push(item.id));
      return idsList;
    }

    //case for bottom item
    const selectedNestedDmaItem = dma.find(
      (item) => `(${item.valueDMA}) ${item.nameDMA}` === node.name
    );

    return [`${selectedNestedDmaItem.valueDMA}`, selectedNestedDmaItem.ST];
  };

  const getOnChange = (checked, nodes) => {
    let array = null;
    const allNode = getSelectedNode(nodes);

    if (checked) {
      array = [...selected, ...allNode];
    } else {
      array = selected.filter((value) => !allNode.includes(value));

      // Condition for upper lvl node, for dma
      if (!Array.isArray(nodes.children)) {
        uncheckParentNodeFirstLvl(nodes.id, array);
      }
    }

    setSelected(array);
  };

  return (
    <TreeView
      expanded={[...isOpenNestedParent]}
      defaultCollapseIcon={<ExpandMoreIcon />}
      defaultExpandIcon={<ChevronRightIcon />}
    >
      {data.map((item) => (
        <TreeItemMiddle
          key={item.id}
          nodes={item}
          selected={selected}
          getOnChange={getOnChange}
          isOpenNestedParent={isOpenNestedParent}
          setIsOpenNestedParent={setIsOpenNestedParent}
        />
      ))}
    </TreeView>
  );
}
